<script>
const { VUE_APP_API_HOST } = process.env  

export default {
  methods: {
    login(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/login`, body)
        .then(res => res, err => err)
    },
    signup(body, params = null){
      return this.$http
        .post(`${VUE_APP_API_HOST}/users${params || ''}`, body)
        .then(res => res, err => err)
    },
    facebook(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/facebook`, body)
        .then(res => res, err => err)
    },
    twitter(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/twitter`, body)
        .then(res => res, err => err)
    },
    password(body){
      return this.$http
        .post(`${VUE_APP_API_HOST}/auth/forgot`, body)
        .then(res => res, err => err)
    },
    verify(id){
      return this.$http
        .get(`${VUE_APP_API_HOST}/users/verify/${id}`)
        .then(res => res, err => err)
    },
    checkTwitterAccount(id){
      return this.$http
        .get(`${VUE_APP_API_HOST}/auth/check-twitter-account/${id}`)
        .then(res => res, err => err)
    },
    viewerLogin(key) {
      return this.$http
        .get(`${VUE_APP_API_HOST}/auth/viewer-login?viewer=${key}`)
        .then(res => res, err => err)
    },
  }
}
</script>